var map = {
	"./advanced-mine.svg": 28,
	"./archeological-dig.svg": 29,
	"./armada.svg": 30,
	"./automotive-plant.svg": 31,
	"./bridge.svg": 32,
	"./building.svg": 33,
	"./burial-site.svg": 34,
	"./canoes.svg": 35,
	"./city.svg": 36,
	"./coal-mine.svg": 37,
	"./coal-powerplant.svg": 38,
	"./coal.svg": 39,
	"./coast.svg": 40,
	"./crayfishery.svg": 41,
	"./cultivation.svg": 42,
	"./dam.svg": 43,
	"./data-center.svg": 44,
	"./facility.svg": 45,
	"./factory.svg": 46,
	"./farm.svg": 47,
	"./fishery.svg": 48,
	"./fishing-village.svg": 49,
	"./forest.svg": 50,
	"./forestry.svg": 51,
	"./forge.svg": 52,
	"./glass-furnace.svg": 53,
	"./gold.svg": 54,
	"./healing-roots.svg": 55,
	"./herded-sheep.svg": 56,
	"./hills.svg": 57,
	"./hospital.svg": 58,
	"./icon.svg": 59,
	"./kelp-farm.svg": 60,
	"./land.svg": 13,
	"./lighthouse.svg": 61,
	"./livestock.svg": 62,
	"./log.svg": 10,
	"./market.svg": 63,
	"./mechanized-farm.svg": 64,
	"./medical-lab.svg": 65,
	"./metropolis.svg": 66,
	"./mountain.svg": 67,
	"./museum.svg": 68,
	"./national-park.svg": 69,
	"./nuclear-powerplant.svg": 70,
	"./observatory.svg": 71,
	"./oil-rig.svg": 72,
	"./oil.svg": 73,
	"./paper-mill.svg": 74,
	"./plains.svg": 75,
	"./port.svg": 76,
	"./primitive-mine.svg": 77,
	"./quarry.svg": 78,
	"./question-mark.svg": 15,
	"./radio-tower.svg": 79,
	"./rare-animals.svg": 80,
	"./remove.svg": 14,
	"./river.svg": 81,
	"./sawmill.svg": 82,
	"./school.svg": 83,
	"./semi-conductor-factory.svg": 84,
	"./ships.svg": 85,
	"./shopping-mall.svg": 86,
	"./soldiers.svg": 87,
	"./spaceport.svg": 88,
	"./steamship.svg": 89,
	"./steel-bridge.svg": 90,
	"./stronghold.svg": 91,
	"./swedish-furniture-store.svg": 92,
	"./tanks.svg": 93,
	"./town.svg": 94,
	"./train-station.svg": 95,
	"./underground-mine.svg": 96,
	"./university.svg": 97,
	"./uranium-mine.svg": 98,
	"./uranium.svg": 99,
	"./watchtower.svg": 100,
	"./water.svg": 101,
	"./watermill.svg": 102,
	"./wind-turbine.svg": 103,
	"./windmill.svg": 104,
	"./zoo.svg": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;